import { PERMISSION_CODE } from "../../constants/constants";

// 画面毎の表示制御
export const userAuthCheck = (
  user: any,
  tenpoCode: string,
  mode: string = ""
) => {
  // 対象職種かつ選択している店舗が担当店か判定
  if (mode === "dailyMulti") {
    // 個店経営状況（サブ）
    if (user.tenpo_code.length === 0) {
      // 担当店をもっていなければNG
      return false;
    }
    if (
      // ZM・DMは除外
      (user.job_category_code_OA !== "120" &&
        user.job_category_code_OA !== "210"&&
        user.tenpo_code.length !== 0) ||
      //SOFC（担当店舗有り）
      (user.job_category_code_OA === "210" &&
        user.tenpo_code_special_list.length !== 0)
    ) {
      return true;
    }
  } else {
    if (user.tenpo_code.includes(tenpoCode)) {
      return true;
    }
  }

  // OFCDの管理ユーザーか判定
  if (isAdminUser(user)) {
    return true;
  }
  return false;
};

// OFCDの管理ユーザーを判定する
export const isAdminUser = (user: any) => {
  // 管理者権限コードが含まれている場合
  if (user.permission_code && user.permission_code.includes(PERMISSION_CODE.ADMIN)) {
      return true;
  } else {
      return false;
  }
};

// 鉄道法人店舗・品揃え分析のみ閲覧可能なユーザーを判定する
export const isAssortmentAnalysisRailwayStoreOnlyUser = (user: any) => {
  // 鉄道法人店舗・品揃え分析のみ閲覧可能な権限コードが含まれている場合
  if(user.permission_code && user.permission_code.includes(PERMISSION_CODE.ASSORTMENT_ANALYSIS_RAILWAY_STORE_ONLY)){
      return true;
  } else {
      return false;
  }
};

// 自店舗のみ・品揃え分析のみ閲覧可能なユーザーを判定する
export const isAssortmentAnalysisOwnStoreOnlyUser = (user: any) => {
  // 自店舗・品揃え分析のみ閲覧可能な権限コードが含まれている場合
    if(user.permission_code && user.permission_code.includes(PERMISSION_CODE.ASSORTMENT_ANALYSIS_OWN_STORE_ONLY)){
      return true;
  } else {
      return false;
  }
};

// 全店舗・品揃え分析のみ閲覧可能なユーザを判定する
export const isAssortmentAnalysisAllStoreUser = (user: any) => {
    // 全店舗・品揃え分析のみ閲覧可能な権限コードが含まれている場合
    if(user.permission_code && user.permission_code.includes(PERMISSION_CODE.ASSORTMENT_ANALYSIS_ALL_STORE)){
      return true;
  } else {
      return false;
  }
}

// 鉄道法人部署所属（自店舗・全メニュー閲覧可能）のユーザーを判定する
export const isRailwayDepartmentUser = (user: any) => {
  // 鉄道法人部署所属の権限コードが含まれている場合
  if(user.permission_code && user.permission_code.includes(PERMISSION_CODE.RAILWAY_DEPARTMENT)){
      return true;
  } else {
      return false;
  }
}